<template>
<div>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline">Asambleas</h3>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assemblies"
      :search="search"
      :loading="loadingTable"
      :rows-per-page-text="$t('datatable.rowsPerPageText')"
      :no-results-text="$t('datatable.noResultsText')"
      :no-data-text="$t('datatable.noDataText')"
      :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.assembly_date }} {{ props.item.assembly_time }}</td>
        <td class="text-xs-center" >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" :class="props.item.assembly_type == 'virtual' ? 'blue--text' : 'purple--text'">{{ $t(`assembly.assembly_types.icons.${props.item.assembly_type}`) }}</v-icon>
            </template>
            <span >{{ $t(`assembly.assembly_types.${props.item.assembly_type}`) }}</span>
          </v-tooltip>
        </td>
        <td class="text-xs-left">{{ props.item.description }}</td>
        <td class="text-xs-left">{{ props.item.responsible_name }}</td>
        <td class="text-xs-center">{{ props.item.delegated_powers_limit }}</td>
        <td class="text-xs-center">{{ props.item.min_attendance_percentage }}</td>
        <td class="text-xs-center" :class="props.item.status == 1 || props.item.status == 2 ? 'red--text' : ''">{{ props.item.status == 0 ? 'Abierta' : props.item.status == 1 ? 'Cerrada' : 'Eliminada' }}</td>
        <td class="text-xs-center" v-if="props.item.status !== 2">
          <v-tooltip v-if="props.item.assembly_type != 'virtual'" top>
            <v-icon
              medium
              class="mr-2"
              @click="takeAssistance(props.item.id)"
              slot="activator"
            >
              assignment
            </v-icon>
          <span>Tomar asistencia</span>
        </v-tooltip>
        <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="report(props.item.id)"
            slot="activator"
          >
            pie_chart
          </v-icon>
          <span>Ver informes</span>
        </v-tooltip>
        <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="openDialog(props.item.id, props.item.description)"
            slot="activator"
          >
            people
          </v-icon>
          <span>Miembros de junta</span>
        </v-tooltip>
        <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="handleQuestions(props.item)"
            slot="activator"
          >
            question_answer
          </v-icon>
          <span>Preguntas</span>
        </v-tooltip>
        <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="auditPowers(props.item.id, props.item.description)"
            slot="activator"
          >
            find_in_page
          </v-icon>
          <span>Auditoría de poderes</span>
        </v-tooltip>
        <v-tooltip v-show="props.item.status == 0" top>
          <v-icon
            medium
            class="mr-2"
            @click="editItem(props.item)"
            slot="activator"
          >
            edit
          </v-icon>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip v-show="props.item.status == 0" top>
          <v-icon
            medium
            @click="modalDeleteAssembly = true; selectedAssembly = props.item"
            slot="activator"
          >
            delete
          </v-icon>
          <span>Eliminar</span>
        </v-tooltip>
        </td>
        <td v-else></td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="modalDeleteAssembly"
      max-width="440"
      persistent
    >
      <v-card>
        <v-card-title class="title red--text text--darken-4">Eliminar Asamblea</v-card-title>
        <v-card-text>
          ¿Está seguro de eliminar la asamblea <b>{{ selectedAssembly ? selectedAssembly.description : '' }}</b>?
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="deleteItem(selectedAssembly)"
            title="Eliminar asamblea"
            color="red darken-2"
            :loading="isLoading"
            :disabled="isLoading"
            flat>
            Si, eliminar
          </v-btn>
          <v-btn
            @click="modalDeleteAssembly = false"
            title="Cancelar"
            color="grey"
            :loading="isLoading"
            :disabled="isLoading"
            flat>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Miembros de junta asamblea {{ dialogAssembly }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs10>
                <v-autocomplete
                  v-model="currentMemberSearch"
                  :items="usersResult"
                  :loading="isLoading"
                  :search-input.sync="searchBoardMembers"
                  color="primary"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="name"
                  placeholder="Buscar personas"
                  return-object
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1>
                <v-btn @click="addMember()" flat icon color="primary">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs1>
                <v-btn @click="showCreateMemberForm = true" icon color="primary">
                  <v-icon>person_add</v-icon>
                </v-btn>
              </v-flex>


            </v-layout>
            <v-layout v-show="showCreateMemberForm" wrap>
              <v-flex xs12>
                <form @submit.prevent="createMemberUser" @keydown="createMemberForm.onKeydown($event)">
                  <text-input
                    :form="createMemberForm"
                    label="Nombre completo"
                    :v-errors="errors"
                    :value.sync="createMemberForm.name"
                    counter="30"
                    name="name"
                    v-validate="'required|max:30'"
                  ></text-input>
                </form>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-data-table
                :headers="boardMembersHeaders"
                :items="boardMembers"
                :search="boardMembersSearch"
              >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">
                  <v-icon
                    small
                    @click="deleteMember(props.item.id_assembly, props.item.id)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
              </v-data-table>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogAudit" max-width="980px">
      <v-card>
        <v-card-title>
          <span class="headline">Auditoría de poderes - {{ dialogAssembly }}</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="auditPowerSearch"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row class="ma-0 pa-0">
            <v-data-table
              :headers="auditPowerHeaders"
              :items="auditPowerItems"
              :search="auditPowerSearch"
              :items-per-page="10"
              :rows-per-page-text="$t('datatable.rowsPerPageText')"
              :no-results-text="$t('datatable.noResultsText')"
              :no-data-text="$t('datatable.noDataText')"
              :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
              :loading="isLoading"
              class="mt-2 table-striped"
              style="width: 100%"
            >
              <template slot="items" slot-scope="props">
                <td class="no-wrap" :style="!!props.item.reviewed ? 'background-color: #Ebffeb' : ''">
                  <v-hover>
                    <v-btn
                      v-if="props.item.document_signed"
                      @click="checkPower(props.item.id, !!props.item.reviewed)"
                      :title="!!props.item.reviewed ? 'Revisado: '+props.item.reviewed : 'Marcar como revisado'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${!!props.item.reviewed ? hover ? 'green lighten-2' : 'green lighten-2' : 'grey'}`"
                      flat icon small >
                      <v-icon>check_circle_outline</v-icon>
                    </v-btn>
                  </v-hover>
                  {{ props.item.family_name }}
                  <v-tooltip top color="info">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" flat icon small color="blue lighten-2"
                        @click="showPowersHistory(props.item.family_id, props.item.family_name)">
                        <v-icon>info</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver detalle</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-center">
                    <span v-show="props.item.employee2 === 1" >
                      Emp
                    </span>
                    <span v-show="props.item.asopaf2 === 1" >
                      Asop
                    </span>
                </td>
                <td class="text-xs-center" :class="props.item.document_status == 'R' ? 'red--text text--darken-2' : ''">
                    <v-hover>
                      <v-btn
                        v-if="['F','R'].includes(props.item.document_status)"
                        @click="viewPower(props.item.document_signed)"
                        :title="props.item.document_status == 'R' ? 'Rechazado por administrador' : 'Ver poder'"
                        slot-scope="{ hover }"
                        class="mx-0"
                        :color="`${props.item.document_status == 'F' ? hover ? 'blue lighten-2' : 'grey' : 'red'}`"
                        flat icon small >
                        <v-icon>launch</v-icon>
                      </v-btn>
                    </v-hover>
                    <v-hover>
                      <v-btn
                        v-if="['F'].includes(props.item.document_status)"
                        @click="rejectPowerPrompt(props.item.document_signed, props.item.family_id, props.item.family_name, props.item.family_receives_power_id)"
                        title="Rechazar poder"
                        :color="`${hover ? 'red darken-2' : 'grey'}`"
                        class="mx-0"
                        slot-scope="{ hover }"
                        flat icon small  >
                        <v-icon>highlight_off</v-icon>
                      </v-btn>
                    </v-hover>
                    <span>{{ !['F','R'].includes(props.item.document_status) ? 'Sin firmar' : '' }}</span>
                </td>
                <td class="no-wrap" :style="!!props.item.receives_reviewed ? 'background-color: #Ebffeb' : ''">
                  <v-hover>
                    <v-btn
                      v-if="props.item.family_receives_vista_id"
                      @click="checkPower(props.item.id_receives, !!props.item.receives_reviewed)"
                      :title="!!props.item.receives_reviewed ? 'Revisado: '+props.item.receives_reviewed : 'Marcar como revisado'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${!!props.item.receives_reviewed ? hover ? 'green lighten-2' : 'green lighten-2' : 'grey'}`"
                      flat icon small >
                      <v-icon>check_circle_outline</v-icon>
                    </v-btn>
                  </v-hover>
                  {{ props.item.family_receives_name }}
                </td>
                <td class="text-xs-center">
                    <span v-show="props.item.employee === 1" >
                      Emp
                    </span>
                    <span v-show="props.item.asopaf === 1" >
                      Asop
                    </span>
                </td>
                <td class="text-xs-center" :title="props.item.family_receives_power_updated_at ? props.item.family_receives_power_updated_at.substring(0,16) : ''" v-html="props.item.family_receives_power_status == 'A' ? 'Aceptado' : props.item.family_receives_power_status == 'R' ? 'Rechazado<br>apoderado' : 'Pendiente'"></td>
                <td class="text-xs-center"  :class="props.item.family_receives_vista_status == 'P' ? 'red--text text--darken-2' : ''">
                  <v-hover>
                    <v-btn
                      v-if="props.item.family_receives_vista_id && props.item.family_receives_power_status == 'A'"
                      @click="viewPower(props.item.family_receives_vista_id)"
                      :title="props.item.family_receives_vista_status == 'R' ? 'Rechazado por administrador' : 'Ver poder'"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${props.item.family_receives_vista_status == 'F' ? hover ? 'blue lighten-2' : 'grey' : 'red'}`"
                      flat icon small >
                      <v-icon>launch</v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover>
                    <v-btn
                      v-if="props.item.family_receives_vista_id && props.item.family_receives_power_status == 'A'"
                      @click="rejectPowerPrompt(props.item.family_receives_vista_id, props.item.family_receives_power_id, props.item.family_receives_name,  props.item.family_id)"
                      title="Rechazar poder"
                      :color="`${hover ? 'red darken-2' : 'grey'}`"
                      class="mx-0"
                      slot-scope="{ hover }"
                      flat icon small  >
                      <v-icon>highlight_off</v-icon>
                    </v-btn>
                  </v-hover>
                  <span v-html="props.item.family_receives_vista_status == 'R' ? 'Rechazado<br>administrador' : props.item.family_receives_vista_status != 'F' && props.item.family_receives_power_status != 'R' ? 'Sin firmar' : ''"></span>
                </td>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" outline icon="warning">
                  Su búsqueda para <b>"{{ auditPowerSearch }}"</b> no obtuvo resultados.
                </v-alert>
              </template>
            </v-data-table>

            <v-dialog v-model="dialogPowersHistory" scrollable max-width="920px">
              <v-card>
                <v-card-title class="title">Histórico de Poderes - {{ powerHistoryFamilyName }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 400px;" class="pa-0">

                  <v-data-table
                    :headers="powersHistoryHeaders"
                    :items="powerHistoryDetail"
                    :items-per-page="10"
                    :rows-per-page-text="$t('datatable.rowsPerPageText')"
                    :no-results-text="$t('datatable.noResultsText')"
                    :no-data-text="$t('datatable.noDataText')"
                    :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
                    :loading="isLoading"
                    class="mt-2"
                  >
                    <template v-slot:items="props">
                      <tr :class="props.item.status == '1' ? 'grey--text' : ''">
                        <td>{{ props.item.created_at.substr(0, 16) }}</td>
                        <td>{{ props.item.document_name }} {{ props.item.status }}</td>
                        <td>{{ props.item.family_receives_power_id }}<br>{{ props.item.family_receives_name }}</td>
                        <td>{{ props.item.family_receives_power_status }}<br>{{ props.item.family_receives_power_status ? props.item.family_receives_power_updated_at.substring(0,16) : props.item.created_at.substring(0,16) }}</td>
                        <td>{{ props.item.document_status }}</td>
                      </tr>
                    </template>
                  </v-data-table>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" flat @click="dialogPowersHistory = false">{{ $t('close') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialogDigitalSign"
              fullscreen>
              <!-- <v-layout>
                <v-flex style="background-color:white;" lg4>
                  <b>signAction: {{ signAction }}</b><br>
                  rowidTercero: {{ rowidTercero }}<br>
                  documentSignId: {{ documentSignId }}<br>
                  vistaAction: {{ vistaAction }}<br>
                  documentProcessId: {{ documentProcessId }}<br>
                  vistaRecordId: {{ vistaRecordId }}
                </v-flex>
              </v-layout> -->
              <DigitalSignComponent
                v-if="dialogDigitalSign"
                v-on:closeDialog="dialogDigitalSign = false"
                :documentId="documentSignId"
                :action="vistaAction"
                :processId="documentProcessId"
                :recordId="vistaRecordId"
              ></DigitalSignComponent>
            </v-dialog>

            <v-dialog
              v-model="dialogRejectPower"
              max-width="680"
            >
              <v-card>
                <v-card-title class="title red--text text--darken-4">Rechazo de documento de poder (asamblea virtual)</v-card-title>
                <v-card-text>
                  <v-container grid-list-md text-xs-center px-0>
                    <v-layout row wrap>
                      <v-flex xs5>
                        <v-select
                          :items="[
                            { value: 'fotografía', name: 'Rechazo por Fotografía' },
                            { value: 'firma', name: 'Rechazo por Firma' },
                          ]"
                          v-model="toRejectReason"
                          label="Razón del rechazo"
                          item-text="name"
                          item-value="value"
                          ></v-select>
                      </v-flex>
                      <v-flex xs7>
                        <v-text-field
                          v-model="toRejectObservation"
                          label="Observaciones (Visibles para el usuario)"
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  Está seguro de rechazar el documento # <b>{{ toRejectPowerId }}</b> de la familia <b>{{ toRejectFamilyName }}</b>?
                  <br>
                  <small>Recuerde que además del rechazo del documento, le llegará una notificación vía correo electrónico, indicando que el rechazo fue por motivo de calidad en la información</small>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    color="red darken-4"
                    flat="flat"
                    :disabled="!toRejectReason || !toRejectObservation"
                    @click="rejectPower"
                  >
                    {{ $t('accept') }}
                  </v-btn>

                  <v-btn
                    color="grey"
                    flat="flat"
                    @click="dialogRejectPower = false"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogAudit = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-if="selectedAssembly"
      v-model="dialogQuestions"
      persistent
      :scrollable="true"
      max-width="1100px" >
      <v-card color="grey lighten-4">
        <v-card-title>
          <span class="headline">Preguntas <small>{{ selectedAssembly.description }} <span v-if="selectedAssembly.assembly_finish_time" class='red--text'>cierre: {{ selectedAssembly.assembly_finish_time.substring(0,5) }}</span></small></span>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn @click="handleQuestions(selectedAssembly)" :loading="isLoading" icon dark color="blue" slot="activator"><v-icon>cached</v-icon></v-btn>
            <span>Actualizar</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn @click="dialogQuestions = false" :loading="isLoading" icon dark color="grey" slot="activator"><v-icon>close</v-icon></v-btn>
            <span>Cerrar</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-layout row wrap>
            <v-flex
              v-for="(question, index) in assemblyQuestions"
              :key="`question-${index}`"
              xs12 sm12 md6 lg6
              >
              <v-card
                elevation-1
                class="ma-2"
                >
                <v-card-title class="title pb-0">
                  <div>{{ index+1 }} - {{ question.name }}
                    <span v-if="question.attachment_url" class="d-inline cursor-help" title="tiene adjunto"><v-icon class="blue--text">attach_file</v-icon></span>
                    <span v-if="question.target_audience != 'GENERALPUBLIC'" class="d-inline cursor-help" title="Para grupo cerrado"><v-icon class="orange--text">security</v-icon></span>
                    <span v-if="!!question.active_date" class="d-inline cursor-help pink--text body-1" title="Ya fue publicada"><v-icon class="pink--text">alarm_on</v-icon>{{ getTotalAnswer(question.id) }} de {{ assemblyQuorum[question.target_audience] }}</span>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div style="height:110px; overflow: auto;">
                    <b>{{ question.description }}</b>
                    <ul v-if="question.question_type != 'YESNO' ">
                      <li
                        v-for="detail in question.question_detail"
                        :key="detail.id"
                      >
                        {{ detail.text }} <div style="float:right; margin-right: 5px;" v-if="!!question.active_date" v-html="getAnswer(question.id, detail.id)"></div>
                      </li>
                    </ul>
                    <ul v-else>
                      <li>Si <div style="float:right; margin-right: 5px;" v-if="!!question.active_date" v-html="getAnswer(question.id, 'YES')"></div></li>
                      <li>No <div style="float:right; margin-right: 5px;" v-if="!!question.active_date" v-html="getAnswer(question.id, 'NO')"></div></li>
                    </ul>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-hover>
                    <v-btn
                      @click="promptQuestion(question, 'active')"
                      title="Activar pregunta"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :disabled="!!question.active_date && !question.deactive_date"
                      :color="`${ hover ? 'pink darken-2' : 'grey' }`"
                      flat icon  >
                      <v-icon>{{ !question.deactive_date ? 'alarm_on' : 'snooze' }}</v-icon>
                    </v-btn>
                  </v-hover>
                  {{ question.active_date ? question.active_date.substr(0,16) : '' }}
                  {{ question.deactive_date ? ' a '+question.deactive_date.substr(11,5) : '' }}
                    <v-btn
                      v-if="!!question.active_date && !question.deactive_date"
                      @click="promptQuestion(question, 'deactive')"
                      title="Desactivar pregunta (detener tiempo)"
                      class="mx-0"
                      :disabled="!!question.deactive_date"
                      color="purple darken-2"
                      flat icon  >
                      <v-icon>stop</v-icon>
                    </v-btn>
                  <v-hover v-if="!question.active_date">
                    <v-btn
                      @click="editQuestion(question)"
                      title="Editar pregunta"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${ hover ? 'orange darken-1' : 'grey' }`"
                      flat icon  >
                      <v-icon>create</v-icon>
                    </v-btn>
                  </v-hover>
                  <v-hover v-if="!question.active_date">
                    <v-btn
                      @click="promptQuestion(question, 'remove')"
                      title="Eliminar pregunta"
                      slot-scope="{ hover }"
                      class="mx-0"
                      :color="`${ hover ? 'red darken-2' : 'grey' }`"
                      flat icon  >
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </v-hover>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-dialog
            v-model="modalRemoveQuestion"
            max-width="440"
            persistent
          >
            <v-card>
              <v-card-title class="title red--text text--darken-4">Eliminar pregunta</v-card-title>
              <v-card-text>
                ¿Está seguro de eliminar la pregunta <b>{{ selectedQuestion.name }}</b>?
              </v-card-text>
              <v-card-actions>
                <v-btn
                  @click="removeQuestion"
                  title="Eliminar pregunta"
                  color="red darken-2"
                  :loading="isLoading"
                  :disabled="isLoading"
                  flat>
                  Si, eliminar
                </v-btn>
                <v-btn
                  @click="modalRemoveQuestion = false"
                  title="Cancelar"
                  color="grey"
                  :loading="isLoading"
                  :disabled="isLoading"
                  flat>
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="modalActiveQuestion"
            max-width="440"
            persistent
          >
            <v-card>
                <v-card-title class="title pink--text text--darken-4">Activar pregunta</v-card-title>
                <v-card-text>
                  ¿Está seguro de activar la pregunta <b>{{ selectedQuestion.name }}</b>?<br>
                  <small>Esta pregunta quedará activa en el Panel de Asamblea de todos los participantes. No podrá editarla, ni eliminarla una vez sea activada.</small>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    @click="activeQuestion"
                    title="Activar pregunta"
                    color="pink darken-2"
                    :loading="isLoading"
                    :disabled="isLoading"
                    flat>
                    Si, activar
                  </v-btn>
                  <v-btn
                    @click="modalActiveQuestion = false"
                    title="Cancelar"
                    color="grey"
                    :loading="isLoading"
                    :disabled="isLoading"
                    flat>
                    Cancelar
                  </v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>

           <v-dialog
            v-model="modalDeactiveQuestion"
            max-width="440"
            persistent
          >
            <v-card>
                <v-card-title class="title purple--text text--darken-4">Desactivar pregunta (detener tiempo)</v-card-title>
                <v-card-text>
                  ¿Está seguro de desactivar la pregunta <b>{{ selectedQuestion.name }}</b>?<br>
                  <small>Esta pregunta quedará inactiva en el Panel de Asamblea de todos los participantes. No podrán responderla.</small>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    @click="deactiveQuestion"
                    title="Desactivar pregunta"
                    color="purple darken-2"
                    :loading="isLoading"
                    :disabled="isLoading"
                    flat>
                    Si, desactivar
                  </v-btn>
                  <v-btn
                    @click="modalDeactiveQuestion = false"
                    title="Cancelar"
                    color="grey"
                    :loading="isLoading"
                    :disabled="isLoading"
                    flat>
                    Cancelar
                  </v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="modalEditQuestion"
            max-width="860"
            persistent
          >
            <v-card>
              <v-toolbar card dark color="primary">
                <v-btn icon dark @click="modalEditQuestion = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Pregunta: {{ selectedQuestion.name }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pa-0">
                <v-tabs v-model="questionsTab" align-left
                  color="grey lighten-4"
                  slider-color="accent"
                  md12 lg12 xl12
                  class="elevation-2" >
                  <v-tab key="question"><v-icon class="mr-2">contact_support</v-icon> Pregunta</v-tab>
                  <v-tab key="options" :disabled="!questionForm.id || questionForm.question_type == 'YESNO'"><v-icon class="mr-2">tune</v-icon> Opciones <span v-if="selectedQuestion.question_detail && selectedQuestion.question_detail.length > 0" class="pl-1">({{ selectedQuestion.question_detail.length }})</span></v-tab>
                  <v-tab key="attachments" :disabled="!questionForm.id"><v-icon class="mr-2">attachment</v-icon> Adjuntos ({{ questionForm.attachment_url ? questionForm.attachment_url.split(",").length : 0 }})</v-tab>
                  <v-tab-item key="question">
                    <v-card flat>
                      <progress-bar :show="questionForm.busy"></progress-bar>
                      <form ref="question_form" @submit.prevent="submitEditQuestion" @keydown="questionForm.onKeydown($event)">
                        <v-card-text class="pa-0">
                          <v-container grid-list-md>
                            <v-layout row wrap>
                              <v-flex xs6 md3 lg4>
                                <select-input
                                  :form="questionForm"
                                  label="Tipo de pregunta"
                                  :items="question_types"
                                  item-disabled="disabled"
                                  :v-errors="errors"
                                  :value.sync="questionForm.question_type"
                                  name="question_type"
                                  v-validate="'required'"
                                ></select-input>
                              </v-flex>
                              <v-flex xs6 md3 lg4>
                                <select-input
                                  :form="questionForm"
                                  label="Público objetivo"
                                  :items="target_audiences"
                                  item-disabled="disabled"
                                  :v-errors="errors"
                                  :value.sync="questionForm.target_audience"
                                  name="target_audience"
                                  v-validate="'required'"
                                ></select-input>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6 md5 lg5>
                                <text-input
                                  :form="questionForm"
                                  label="Titulo"
                                  autocomplete="question_name"
                                  :v-errors="errors"
                                  :value.sync="questionForm.name"
                                  :name="'name'"
                                  counter="100"
                                  v-validate="'max:100'"
                                ></text-input>
                              </v-flex>
                              <v-flex xs6 md7 lg7>
                                <text-area-input
                                  :form="questionForm"
                                  label="Descripción"
                                  autocomplete="question_description"
                                  :v-errors="errors"
                                  :value.sync="questionForm.description"
                                  counter="300"
                                  name="description"
                                  v-validate="'required|max:300'"
                                ></text-area-input>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red darken-4"
                            flat="flat"
                            :loading="questionForm.busy"
                            type="submit"
                          >
                            {{ $t('save') }}
                          </v-btn>
                          <v-btn
                            color="grey"
                            flat="flat"
                            :loading="questionForm.busy"
                            @click="modalEditQuestion = false"
                          >
                            {{ $t('cancel') }}
                          </v-btn>
                        </v-card-actions>
                      </form>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="options">
                    <v-card flat>
                      <progress-bar :show="isLoading"></progress-bar>
                      <v-card-text class="pa-0">
                        <v-container v-if="questionForm.question_type == 'SINGLECHOICE' && !!selectedQuestion.question_detail" grid-list-md class="pa-2 ma-1">
                          <v-layout
                            v-for="(question_detail, index) in JSON.parse(JSON.stringify(selectedQuestion.question_detail))"
                            :key="question_detail.id"
                          >
                            <v-flex sm9 md10 lg10 xl10 v-if="question_detail.status == 0">
                              <v-text-field
                                v-model="question_detail.text"
                                :label="`Opción ${index+1}`"
                                :rules="[rulesQuestion.required, rulesQuestion.counter]"
                                :prefix="`${index+1})`"
                                single-line
                                counter=100
                                maxlength="100"
                                clearable
                                :hint="`Escriba el texto de la opción # ${index+1}`"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm3 md2 lg2 xl2 v-if="question_detail.status == 0">
                              <v-hover>
                                <v-btn
                                  @click="selectedOption = question_detail; editQuestionDetail(question_detail, index)"
                                  title="Editar opción"
                                  slot-scope="{ hover }"
                                  class="mx-0"
                                  :color="`${ hover ? 'blue darken-2' : 'grey' }`"
                                  :loading="isLoading && index == selectedQuestionIndex"
                                  flat >
                                Votar <v-icon class="ml-2">send</v-icon>
                                </v-btn>
                              </v-hover>
                              <v-hover>
                                <v-btn
                                  @click="selectedOption = question_detail; removeQuestionDetail(question_detail, index)"
                                  title="Eliminar opción"
                                  slot-scope="{ hover }"
                                  class="mx-0"
                                  :color="`${ hover ? 'red darken-2' : 'grey' }`"
                                  :loading="isLoading && index == selectedQuestionIndex"
                                  flat icon >
                                  <v-icon>remove_circle</v-icon>
                                </v-btn>
                              </v-hover>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex sm9 md10 lg10 xl10>
                              <v-text-field
                                v-model="newQuestionDetail"
                                label="Nueva opción"
                                :rules="[rulesQuestion.counter]"
                                single-line
                                color="cyan darken"
                                counter=100
                                clearable
                                maxlength="100"
                                hint="Escriba el texto de la nueva opción"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm3 md2 lg2 xl2>
                              <v-hover>
                                <v-btn
                                  @click="addQuestionDetail"
                                  title="Nueva pregunta"
                                  slot-scope="{ hover }"
                                  class="mx-0"
                                  :color="`${ hover ? 'cyan darken' : 'grey' }`"
                                  :loading="isLoading && newQuestionDetail != ''"
                                  flat icon  >
                                  <v-icon>{{ newQuestionDetail != '' ? 'send' : 'add_circle' }}</v-icon>
                                </v-btn>
                              </v-hover>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="grey"
                            flat="flat"
                            :loading="isLoading"
                            @click="modalEditQuestion = false"
                          >
                            {{ $t('close') }}
                          </v-btn>
                        </v-card-actions>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="attachments">
                    <v-card>
                      <progress-bar :show="isLoading"></progress-bar>
                      <v-card-text>
                        <v-container grid-list-md class="pa-2 ma-1">
                          <v-layout>
                            <v-flex xs6 md5 lg5>
                              <div class="file-btn">
                                <file-upload
                                  ref="upload"
                                  v-model="files"
                                  class="pt-1 v-btn theme--dark primary"
                                  extensions="pdf,png,jpg,jpeg,gif,mp4,webp,m4v"
                                  accept="application/pdf,image/png,image/jpg,image/jpeg,image/gif,image/webp,video/mp4,video/x-m4v"
                                  :multiple="true"
                                  :size="1024 * 1024 * 10"
                                  @input-filter="inputFilter"
                                  @input-file="inputFile"
                                  >
                                    <v-icon
                                      color="white"
                                      class="mr-2"
                                    >attach_file</v-icon> Seleccionar archivos
                                </file-upload>
                              </div>
                            </v-flex>
                            <v-flex xs6 md7 lg7>
                              <div v-if="files.length > 0" class="upload-files">
                                <ul>
                                  <li v-for="(file) in files" :key="file.id">
                                    <span>{{file.name}}</span> -
                                    <span>{{ (file.size/1024).toFixed(2)}} KB</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span>
                                      <v-tooltip top>
                                        <v-icon
                                          small
                                          class="mr-2"
                                          @click.prevent="$refs.upload.remove(file)"
                                          slot="activator"
                                        >
                                          delete
                                        </v-icon>
                                        <span>Borrar</span>
                                      </v-tooltip>
                                    </span>
                                  </li>
                                </ul>
                                <v-btn
                                  color="primary"
                                  @click="uploadFiles"
                                >
                                  <v-icon class="mr-2">backup</v-icon> Subir archivos
                                </v-btn>
                              </div>
                              <div v-else-if="questionForm && questionForm.attachment_url" class="d-inline-flex">
                                <ul>
                                  <li v-for="(file, index) in questionForm.attachment_url.split(',')" :key="file+index">
                                    <span v-if="file != ''"><a :href="file" target="_blank">Archivo {{index+1}}</a></span>
                                  </li>
                                </ul>
                                <v-btn class="ml-4" @click="questionForm.attachment_url = ''; submitEditQuestion()">Borrar</v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn @click="addQuestion" :loading="isLoading" icon dark color="info" slot="activator"><v-icon>add</v-icon></v-btn>
            <span>Agregar pregunta</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-layout>
</div>

</template>
<script>
import axios from 'axios'
import DigitalSignComponent from '~/pages/documents/digital_sign'
import Form from 'vform';
import FileUpload from 'vue-upload-component'

export default {
  name: 'assemblies-show-view',
  components: {
    DigitalSignComponent,
    FileUpload
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Fecha de asamblea', align: 'center', value: 'assembly_date' },
        { text: 'Tipo', align: 'center', value: 'assembly_type' },
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Responsable', align: 'center', value: 'responsible_name' },
        { text: 'Máx. Poderes', align: 'center', value: 'delegated_powers_limit', sortable: false },
        { text: 'Mín. Asist', align: 'center', value: 'min_attendance_percentage', sortable: false },
        { text: 'Estado', align: 'center', value: 'status' },
        { text: 'Actions', align: 'center', value: 'assembly_date', sortable: false }
      ],
      assemblies: [],
      modalDeleteAssembly: false,
      selectedAssembly: null,
      dialogAssembly: '',
      dialogIdAssembly: 0,
      dialog: false,
      dialogAudit: false,
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentMemberSearch: null,
      searchBoardMembers: null,
      boardMembersHeaders: [
        { text: 'Nombre', value: 'name', align: 'center' },
        { text: 'Actions', value: 'name', sortable: false, align: 'center' }
      ],
      boardMembers: [],
      boardMembersSearch: '',
      auditPowerHeaders: [
        { text: 'Poderdante', value: 'family_name', sortable: true, align: 'center' },
        { text: 'Tipo', value: 'asopaf', sortable: true, align: 'center' },
        { text: 'Vista 360', align: 'center' },
        { text: 'Apoderado', value: 'family_receives_name', align: 'center' },
        { text: 'Tipo', value: 'asopaf2', sortable: true, align: 'center' },
        { text: 'Estado', value: 'family_receives_power_status', sortable: true, align: 'center' },
        { text: 'Vista 360', align: 'center', width: '100px' }
      ],
      auditPowerItems: [],
      auditPowerSearch: null,
      dialogPowersHistory: false,
      powerHistoryFamilyName: null,
      powersHistoryHeaders: [
        { text: 'Fecha', value: 'created_at', align: 'center' },
        { text: 'Documento', value: 'document_name', sortable: false },
        { text: 'Familia destino', value: 'family_receives', sortable: false },
        { text: 'Estado Apoderado', value: 'family_receives_power_status', align: 'center', width: '50px' },
        { text: 'Estado Vista 360', value: 'document_status', align: 'center' },
      ],
      powerHistoryDetail: [],

      dialogDigitalSign: false,
      documentSignId: 0,
      vistaAction: null,
      documentProcessId: 0,
      vistaRecordId: 0,
      dialogRejectPower: false,
      toRejectPowerId: null,
      toRejectFamilyId: null,
      toRejectFamilyTargetId: null,
      toRejectFamilyName: '',
      toRejectReason: null,
      toRejectObservation: null,

      questionsTab: null,
      assemblyQuestions: [],
      assemblyAnswers: [],
      assemblyQuorum: [],
      dialogQuestions: false,
      modalEditQuestion: false,
      modalRemoveQuestion: false,
      modalActiveQuestion: false,
      modalDeactiveQuestion: false,
      selectedQuestion: {},
      selectedOption: null,
      selectedQuestionIndex: null,
      questionForm: new Form({
        id: '',
        name: '',
        description: '',
        question_type: '',
        assembly_id: '',
        attachment_url: '',
      }),
      question_types: [
        { value: 'YESNO', text: this.$t('assembly.question_types.yesno') },
        { value: 'SINGLECHOICE', text: this.$t('assembly.question_types.singlechoice') },
        { value: 'SINGLEPERCENTAGE', text: this.$t('assembly.question_types.singlepercentage'), disabled: true },
      ],
      target_audiences: [
        { value: 'GENERALPUBLIC',  text: this.$t('assembly.target_audiences.generalpublic') },
        { value: 'ASOPAF',  text: this.$t('assembly.target_audiences.asopaf') },
      ],
      files: [],
      fileDialog: false,
      rulesQuestion: {
        required: value => !!value || 'Requerido',
        counter: value => value.length <= 100 || 'Max 100 caracteres',
      },
      newQuestionDetail: '',

      showCreateMemberForm: false,
      createMemberForm: new Form({
        name: ''
      }),
      loadingTable: false,
    }
  },
  created() {
    this.getAssembliesList()
  },
  methods: {
    async getAssembliesList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/assemblies')
      this.assemblies = data;
      this.loadingTable = false;
    },
    editItem(item) {
      this.$router.push({ name: 'assembly.edit', params: {id: item.id}});
    },
    async deleteItem(item) {
      await axios.delete(`/api/assembly/${item.id}`)
      .then(response => {
        if (response.status === 200){
          this.modalDeleteAssembly = false;
          this.$store.dispatch('responseMessage', {
              type: 'success',
              text:  `Asamblea cerrada correctamente`,
          })
        } else {
          alert('Ocurrió un error')
        }
        })
      this.assemblies = this.assemblies.filter(assembly => assembly.id !== item.id);
    },
    openDialog(idAssembly, assembly) {
      this.boardMembers = [];
      this.dialog = true;
      axios.get(`/api/assembly/board_members/${idAssembly}`)
        .then(response => {
          if (response.status === 200) {
            this.boardMembers = response.data;
          }
        })
        .catch(error => {
          console.log(error);
        })
      this.dialogAssembly = assembly;
      this.dialogIdAssembly = idAssembly;
    },
    auditPowers(idAssembly, assemblyName) {
      console.log("in auditPowers()")
      this.auditPowerItems = []
      this.dialogAudit = true
      this.selectedAssembly = idAssembly
      this.isLoading = true
      axios.get(`/api/documents/get_powers/${idAssembly}`)
        .then(response => {
          if (response.status === 200) {
            this.auditPowerItems = response.data
            this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false
        })
      this.dialogAssembly = assemblyName;
      this.dialogIdAssembly = idAssembly;
    },
    showPowersHistory(idFamily, familyName){
      this.dialogPowersHistory = true
      this.powerHistoryDetail = []
      this.powerHistoryFamilyName = `${familyName}`
      this.isLoading = true
      axios.get(`/api/documents/get_powers_detail/${this.selectedAssembly}/${idFamily}`)
        .then(response => {
          if (response.status === 200) {
            this.powerHistoryDetail = response.data
            this.isLoading = false
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false
        })
    },
    viewPower(vista_id){
      this.dialogDigitalSign = true
      this.vistaAction = 'SHOW'
      this.vistaRecordId = vista_id
    },
    rejectPowerPrompt(vista_id, family_id, family_name, another_family_id){
      this.dialogRejectPower = true
      this.toRejectPowerId = vista_id
      this.toRejectFamilyName = family_name
      this.toRejectFamilyId = family_id
      this.toRejectFamilyTargetId = another_family_id
      this.toRejectReason = null
      this.toRejectObservation = null
      // this.dialogDigitalSign = true
      // this.vistaAction = 'SHOW'
      // this.vistaRecordId = vista_id
    },
    checkPower(id, actual_status){
      axios.post('/api/documents/check_power', { id : id })
        .then(response => {
          if (response.status === 200) {
            this.isLoading = false
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text:  `Poder ${actual_status ? '"no-revisado"' : '"revisado"' } correctamente`,
            })
            this.auditPowers(this.selectedAssembly, this.dialogAssembly)
          }
        })
        .catch(error => {
          this.$store.dispatch('responseMessage', {
                type: 'error',
                text:  'Ocurrió un error',
                modal: true
            })
        })
    },
    rejectPower(){
      this.isLoading = true
      let context = this
      let payload = {
          id: context.toRejectPowerId,
          family_id: context.toRejectFamilyId,
          family_name: context.toRejectFamilyName,
          assembly_id: context.selectedAssembly,
          assembly_name: context.dialogAssembly,
          reason: context.toRejectReason,
          observation: context.toRejectObservation,
          another_family_id: context.toRejectFamilyTargetId,
        }
      axios.post('/api/documents/reject_document', payload)
        .then(response => {
          if (response.status === 200) {
            context.isLoading = false
            context.dialogRejectPower = false
            context.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Poder rechazado correctamente (notificado a la familia vía correo electrónico)',
                modal: true
            })
            context.auditPowers(context.selectedAssembly, context.dialogAssembly)
          }
        })
        .catch(error => {
          context.$store.dispatch('responseMessage', {
                type: 'error',
                text:  'Ocurrió un error',
                modal: true
            })
        })
    },
    handleQuestions(assembly, selected_question = null) {
      this.dialogQuestions = true
      this.selectedAssembly = assembly

      let payload = { id: this.selectedAssembly.id, with_answers: 'yes' }
      this.isLoading = true
      axios.post(`/api/assemblyquestions/assembly`, payload)
        .then(response => {
          if (response.status === 200) {
            this.assemblyQuestions = response.data.questions
            this.assemblyAnswers = response.data.answers
            this.assemblyQuorum = response.data.real_quorum
            this.isLoading = false
            if (selected_question){
              let question = this.assemblyQuestions.filter(question => question.id === selected_question.id);
              this.editQuestion(question[0])
              this.newQuestionDetail = ""
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Ocurrió un error, reintente nuevamente',
            modal: false
          })
          this.isLoading = false
        })
    },
    getTotalAnswer(question_id){
      let total = 0;
      this.assemblyAnswers.forEach(function(answerGrp){
        if(answerGrp.assemblyquestion_id == question_id){
          total += answerGrp.count
        }
      })
      return total
    },
    getAnswer(question_id, questiondetail_id){
      let total = 0;
      let count = 0;
      this.assemblyAnswers.forEach(function(answerGrp){
        if(answerGrp.assemblyquestion_id == question_id){
          total+= answerGrp.count
        }
        if(answerGrp.assemblyquestion_id == question_id && answerGrp.answer == questiondetail_id.toString()){
          count = answerGrp.count
        }
      })
      if (!total) total = 1
      let percent = (count/total * 100).toFixed(2);
      return `<b>${count}</b> : ${percent}% <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}" class="v-progress-linear" style="height: 12px; width: 100px; display: inline-flex; margin: 0px;">
                <div class="v-progress-linear__background primary" style="height: 12px; opacity: 0.3; width: 100%;"></div>
                <div class="v-progress-linear__bar">
                  <div class="v-progress-linear__bar__determinate primary" style="width: ${percent}%;"></div>
                </div>
              </div>`;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      // console.log(newFile, oldFile)
      this.questionForm.attachment_url = ''
    },
    uploadFiles() {
      let id = this.questionForm.id
      let formData = new FormData();
      let fileData;
      this.files.forEach((file, index) => {
        console.log("file:", file, this.$refs.upload.get(file.id))
        fileData = this.$refs.upload.get(file.id);
        formData.append(`file_${index}`, fileData.file);
      });
      formData.append('id', id);
      this.isLoading = true
      axios.post(`/api/assemblyquestions/upload_files`, formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then(resp => {
        if (resp.status === 200) {
          const uploaded = this.files.length
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: uploaded+' archivos subidos correctamente',
            modal: false
          })
          this.$refs.upload.clear();
          this.files = [];
          // this.questionForm.attachment_url = files.split(',')
          this.handleQuestions(this.selectedAssembly, this.selectedQuestion)
        }
      })
      .catch(error => console.log(error));
    },
    editQuestion(question){
      this.modalEditQuestion = true
      this.questionsTab = 0
      this.selectedQuestion = question
      this.questionForm.id = question.id
      this.questionForm.question_type = question.question_type
      this.questionForm.target_audience = question.target_audience
      this.questionForm.name = question.name
      this.questionForm.assembly_id = question.assembly_id
      this.questionForm.attachment_url = question.attachment_url
      this.questionForm.description = question.description
    },
    promptQuestion(question, action){
      this.selectedQuestion = question
      this.questionForm.id = question.id
      this.questionForm.question_type = question.question_type
      this.questionForm.target_audience = question.target_audience
      this.questionForm.name = question.name
      this.questionForm.assembly_id = question.assembly_id
      this.questionForm.attachment_url = question.attachment_url
      this.questionForm.description = question.description
      if (action == 'remove'){
        this.modalRemoveQuestion = true
      } else if (action == 'active'){
        this.modalActiveQuestion = true
      } else if (action == 'deactive'){
        this.modalDeactiveQuestion = true
      }
    },
    removeQuestion(){
      let context = this
      context.isLoading = true
      axios.delete(`/api/assemblyquestions/remove/${context.questionForm.id}`)
        .then(response => {
          if (response.status === 200) {
            context.isLoading = false
            context.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Pregunta eliminada correctamente',
                modal: false
            })
            context.modalRemoveQuestion = false
            context.handleQuestions(context.selectedAssembly)
          }
        })
        .catch(error => {
          context.isLoading = false
          context.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Ocurrió un error, reintente nuevamente',
            modal: false
          })
          console.log(error);
        })
    },
    activeQuestion(){
      let context = this
      context.isLoading = true
      axios.post(`/api/assemblyquestions/active`, { id: context.questionForm.id })
      .then(response => {
        if (response.status === 200) {
          context.isLoading = false
          context.$store.dispatch('responseMessage', {
              type: 'success',
              title: 'Pregunta activada correctamente!',
              text:  'A partir de este momento, los asistentes la verán en sus paneles de Asamblea Virtual',
              modal: true
          })
          context.modalActiveQuestion = false
          context.handleQuestions(context.selectedAssembly)
        }
      })
      .catch(error => {
        context.isLoading = false
        context.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Ocurrió un error, reintente nuevamente',
          modal: false
        })
        console.log(error);
      })
    },
    deactiveQuestion(){
      let context = this
      context.isLoading = true
      axios.post(`/api/assemblyquestions/deactive`, { id: context.questionForm.id })
      .then(response => {
        if (response.status === 200) {
          context.isLoading = false
          context.$store.dispatch('responseMessage', {
              type: 'success',
              title: 'Pregunta desactivada correctamente!',
              text:  'A partir de este momento, los asistentes no podrán responder a dicha pregunta',
              modal: true
          })
          context.modalDeactiveQuestion = false
          context.handleQuestions(context.selectedAssembly)
        }
      })
      .catch(error => {
        context.isLoading = false
        context.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Ocurrió un error, reintente nuevamente',
          modal: false
        })
        console.log(error);
      })
    },
    removeQuestionDetail(option, index){
      this.selectedQuestionIndex = index
      this.isLoading = true
      axios.delete(`/api/assemblyquestionsdetail/remove/${option.id}`)
        .then(response => {
          if (response.status === 200) {
            this.isLoading = false
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Opción eliminada correctamente',
                modal: false
            })
            this.selectedOption.status = 1;
            this.handleQuestions(this.selectedAssembly, this.selectedQuestion)
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Ocurrió un error, reintente nuevamente',
            modal: false
          })
          console.log(error);
        })
    },
    addQuestion(){
      this.modalEditQuestion = true
      this.selectedQuestion = {}
      this.questionForm.id = ''
      this.questionForm.question_type = ''
      this.questionForm.name = ''
      this.questionForm.description = ''
      this.questionForm.attachment_url = ''
      this.questionForm.target_audience = ''
      this.questionForm.assembly_id = this.selectedAssembly.id
    },
    addQuestionDetail(){
      let context = this

      if(context.newQuestionDetail.length == 0){
        context.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Escriba un texto para la nueva opción'
        })
        return
      }

      context.isLoading = true
      let payload = {
            assemblyquestion_id: context.selectedQuestion.id,
            text: context.newQuestionDetail
          };
      axios.post('/api/assemblyquestionsdetail/create', payload)
        .then(response => {
          if (response.status === 200) {
            context.isLoading = false
            context.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Opción agregada correctamente',
                modal: false
            })
          }
          context.handleQuestions(context.selectedAssembly, context.selectedQuestion);
        })
        .catch(error => {
          context.isLoading = false
          context.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Ocurrió un error, reintente nuevamente',
            modal: false
          })
          console.log(error);
        })
    },
    editQuestionDetail(option, index){
      this.selectedQuestionIndex = index
      this.isLoading = true
      axios.put('/api/assemblyquestionsdetail/edit', {id: option.id, text: option.text})
        .then(response => {
          if (response.status === 200) {
            this.isLoading = false
            this.$store.dispatch('responseMessage', {
                type: 'success',
                text:  'Opción actualizada correctamente',
                modal: false
            })
            this.handleQuestions(this.selectedAssembly, this.selectedQuestion)
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Ocurrió un error, reintente nuevamente',
            modal: false
          })
          console.log(error);
        })
    },
    async submitEditQuestion(){
      this.isLoading = true

      if (this.questionForm.question_type == '') {
        this.questionForm.errors.set({ question_type: "El tipo de pregunta es obligatorio" }); return
      }
      if (this.questionForm.target_audience == '') {
        this.questionForm.errors.set({ description: "El público objetivo es obligatorio" }); return
      }
      if (this.questionForm.name == '') {
        this.questionForm.errors.set({ name: "El nombre de la pregunta es obligatorio" }); return
      }
      if (this.questionForm.description == '') {
        this.questionForm.errors.set({ description: "La descripción de la pregunta es obligatoria" }); return
      }

      // if (await this.formHasErrors()){
      //   console.log(this.questionForm)
      //   return
      // }

      let result = null
      let text_result = ''
      if (this.questionForm.id){
        result = await this.questionForm.put('/api/assemblyquestions')
        text_result = 'actualizada'
      } else {
        result = await this.questionForm.post('/api/assemblyquestions')
        text_result = 'creada'
      }

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: `Pregunta ${text_result}`,
        });
        this.handleQuestions(this.selectedAssembly, this.questionForm.id ? this.selectedQuestion : { id: result.data } );
      } else {
        this.isLoading = false
        this.modalEditQuestion = false;
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Ocurrió un error, reintente nuevamente',
          modal: false
        })
      }
    },
    addMember() {
      if (this.currentMemberSearch) {
        const { id, name } = this.currentMemberSearch;
        const payload = {
          id_user: id,
          id_assembly: this.dialogIdAssembly
        };
        axios.post('/api/assembly/board_members/add', payload)
          .then(response => {
            if (response.status === 200) {
              this.boardMembers.push({ id, name, id_assembly: this.dialogIdAssembly });
              this.currentMemberSearch = null;
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    deleteMember(id_assembly, id_user) {
      axios.delete(`/api/assembly/board_members/delete/${id_assembly}/${id_user}`)
        .then(response => {
          if (response.status === 200) {
            this.boardMembers = this.boardMembers
              .filter(member => member.id !== id_user);
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    async createMemberUser() {

      if (await this.formHasErrors()) return

      const result = await this.createMemberForm.post('/api/assembly/board_members/create')

      this.currentMemberSearch = {
        id: result.data.id,
        name: this.createMemberForm.name
      };

      this.createMemberForm.clear();
      this.createMemberForm.reset();
      this.showCreateMemberForm = false;
      this.addMember();
    },
    takeAssistance(idAssembly) {
      this.$router.push({ name: 'assembly.take_assistance', params: { id: idAssembly } })
    },
    charts(idAssembly) {
      this.$router.push({ name: 'assembly.report', params: { id: idAssembly } })
    },
    report(idAssembly) { // virtual
      this.$router.push({ name: 'assembly.virtual.report', params: { id: idAssembly } })
    },
  },

  computed: {
    usersResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },

  watch: {
    searchBoardMembers(val) {
      if (!val) return
      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/assembly/search_board_members/${val}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style>
.table-striped tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
 .upload-files {
   color: gray;
   padding: 5px;
 }
 .cursor-help {
   cursor: help;
 }
 a.v-tabs__item:hover {
  text-decoration: none !important;
  font-weight: bolder;
 }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/show.vue